import { render, staticRenderFns } from "./CartTotal.vue?vue&type=template&id=2f0277ec&scoped=true&"
import script from "./CartTotal.vue?vue&type=script&lang=js&"
export * from "./CartTotal.vue?vue&type=script&lang=js&"
import style0 from "./CartTotal.vue?vue&type=style&index=0&id=2f0277ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0277ec",
  null
  
)

/* custom blocks */
import block0 from "./CartTotal.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CartTotal.vue"
export default component.exports